import { TextInput, PasswordInput } from "@mantine/core";
import {
  IconUser,
  IconMail,
  IconPhone,
  IconLock,
  IconBuilding,
} from "@tabler/icons-react";
import { MaskedTextInput } from "@components/CustomInputs/CustomInputs";
import PasswordRequirements from "@components/PasswordRequirements";
import type { FormData, ErrorState } from "../types";

interface FormFieldsProps {
  formData: FormData;
  error: ErrorState;
  onFormDataChange: (field: keyof FormData, value: string) => void;
  onEmailBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  queryEmail?: string;
  showUserBusinessName?: boolean;
}

export const FormFields = ({
  formData,
  error,
  onFormDataChange,
  onEmailBlur,
  queryEmail,
  showUserBusinessName = false,
}: FormFieldsProps) => {
  return (
    <>
      <TextInput
        leftSection={<IconUser color="#A3A9B0" />}
        placeholder="First Name"
        name="firstName"
        radius="md"
        size="xs"
        type="text"
        value={formData.firstName}
        required
        variant="unstyled"
        onChange={(e) => onFormDataChange("firstName", e.target.value)}
      />
      <TextInput
        leftSection={<IconUser color="#A3A9B0" />}
        placeholder="Last Name"
        name="lastName"
        radius="md"
        size="xs"
        type="text"
        value={formData.lastName}
        required
        variant="unstyled"
        onChange={(e) => onFormDataChange("lastName", e.target.value)}
      />
      {showUserBusinessName && (
        <>
          <TextInput
            leftSection={<IconBuilding color="#A3A9B0" />}
            placeholder="Business Name"
            name="userBusinessName"
            radius="md"
            size="xs"
            type="text"
            value={formData.userBusinessName ?? ""}
            required
            variant="unstyled"
            onChange={(e) =>
              onFormDataChange("userBusinessName", e.target.value)
            }
          />
        </>
      )}
      <TextInput
        leftSection={<IconMail color="#A3A9B0" />}
        placeholder="Email Address"
        name="email"
        radius="md"
        size="xs"
        type="text"
        value={formData.email}
        disabled={queryEmail !== "" && queryEmail !== undefined}
        required
        variant="unstyled"
        pattern="[^ @]*@[^ @]*"
        onChange={(e) => onFormDataChange("email", e.target.value)}
        onBlur={onEmailBlur}
        {...(error.email && { error: error.email })}
      />
      <MaskedTextInput
        leftSection={<IconPhone color="#A3A9B0" />}
        placeholder="Phone Number"
        name="phoneNumber"
        mask="(000) 000-0000"
        radius="md"
        size="xs"
        type="text"
        value={formData.phoneNumber}
        className="phone-number"
        required
        variant="unstyled"
        onChange={(e) =>
          onFormDataChange("phoneNumber", (e.target as HTMLInputElement).value)
        }
      />
      <PasswordRequirements
        value={formData.password}
        setValue={(value) => onFormDataChange("password", value as string)}
        placeholder="Create Password"
        name="password"
        size="xs"
        error={error.password}
      />
      <PasswordInput
        leftSection={<IconLock color="#A3A9B0" />}
        placeholder="Re-enter Password"
        name="reenterPassword"
        className="password"
        radius="md"
        size="xs"
        type="password"
        value={formData.reenteredPassword}
        error={error.password}
        required
        variant="unstyled"
        onChange={(e) => onFormDataChange("reenteredPassword", e.target.value)}
      />
    </>
  );
};
